<script setup lang="ts">
useSeoMeta({
  title: 'Contact QikSolve',
  description: 'Contact QikSolve for regulatory compliance and Microsoft 365 quality management support.',
});

useHead({
  script: [
    {
      src: 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js',
      async: true,
      defer: true,
    },
  ],
});
</script>

<template>
  <section class="max-w-3xl mx-auto px-4 py-16">
    <h1 class="text-3xl font-bold mb-2">
      Contact Us
    </h1>
    <p class="text-gray-600 mb-8">
      Feel free to contact us for any questions and doubts. We just need a couple of hours! No more than 2
      working days since receiving your issue ticket.
    </p>

    <div class="grid gap-8 sm:grid-cols-3">
      <div>
        <h2 class="font-semibold mb-1">
          Email Us
        </h2>
        <a
          href="mailto:info@qiksolve.com"
          class="text-blue-600 underline"
        >info@qiksolve.com</a>
      </div>
      <div>
        <h2 class="font-semibold mb-1">
          Address
        </h2>
        <p class="text-gray-600">
          Level 23, Collins Square Tower Five, 727 Collins Street Melbourne VIC 3008
        </p>
      </div>
      <div>
        <h2 class="font-semibold mb-1">
          Call Us
        </h2>
        <a
          href="tel:+61386781702"
          class="text-blue-600 underline"
        >+61 (3) 8678 1702</a>
      </div>
    </div>

    <section class="mt-16 border-t border-gray-200 pt-12">
      <h2 class="text-2xl font-heading font-bold text-gray-900 mb-3">
        Book a discovery call
      </h2>
      <p class="text-gray-600 mb-6">
        Bring your quality challenge and we can explore the right Microsoft 365, product, and implementation
        pathway together.
      </p>
      <iframe
        src="https://meetings-ap1.hubspot.com/matthew-schoerie/lunarheart-discovery-booking?embed=true"
        title="Book a discovery call with QikSolve"
        class="min-h-[680px] w-full border-0"
        loading="lazy"
      />
      <p class="mt-4 text-sm text-gray-600">
        If the scheduler does not load,
        <a
          href="https://meetings-ap1.hubspot.com/matthew-schoerie/lunarheart-discovery-booking"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold text-brand-700 underline"
        >book directly through HubSpot Meetings</a>.
      </p>
    </section>

    <!-- TODO: wire contact form submission to CRM/Table Storage endpoint, per qx-solarheart review-interest pattern -->
  </section>
</template>
